// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.IconButton__container-eb0b20 {
  --ib-border-radius: 50%;
  --ib-border-width: 0;
  --ib-border-color: transparent;
  flex-shrink: 0;
  position: relative;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  transition: background 0.3s ease, color 0.3s ease;
  cursor: pointer;
  box-sizing: border-box;
  color: var(--ib-color);
  background: var(--ib-background);
  border-radius: var(--ib-border-radius);
  -webkit-tap-highlight-color: transparent;
  border: var(--ib-border-width) solid var(--ib-border-color);
}

.IconButton__container-eb0b20 .IconButton__dot-badge-acd0d3 {
  border-color: var(--ib-background);
}

.IconButton__container-eb0b20:hover,
.IconButton__container-eb0b20.IconButton__active-b5eb48 {
  color: var(--ib-color-hover);
  background: var(--ib-background-hover);
}

.IconButton__container-eb0b20:hover .IconButton__dot-badge-acd0d3,
.IconButton__container-eb0b20.IconButton__active-b5eb48 .IconButton__dot-badge-acd0d3 {
  border-color: var(--ib-background-hover);
}

.IconButton__container-eb0b20:active {
  color: var(--ib-color-active);
  background: var(--ib-background-active);
}

.IconButton__container-eb0b20:active .IconButton__dot-badge-acd0d3 {
  border-color: var(--ib-background-active);
}

.IconButton__container-eb0b20:focus {
  color: var(--ib-color-hover);
  background: var(--ib-background-hover);
}

.IconButton__container-eb0b20:focus .IconButton__dot-badge-acd0d3 {
  border-color: var(--ib-background-hover);
}

.IconButton__container-eb0b20:disabled {
  cursor: default;
  color: var(--ib-color-disabled);
  background: var(--ib-background-disabled);
}

.IconButton__container-eb0b20:disabled .IconButton__dot-badge-acd0d3 {
  border-color: var(--ib-background-disabled);
}

.IconButton__dot-badge-acd0d3 {
  position: absolute;
  width: 8px;
  height: 8px;
  top: 6px;
  inset-inline-end: 6px;
  border-radius: 50%;
  border: solid 2px var(--base-0);
  background: var(--brand-primary-40);
  transition: border-color 0.3s ease;
}

.IconButton__disabled-f4af89 {
  pointer-events: none;
}

.IconButton__disabled-icon-fcd4c1 {
  opacity: 0.5;
}

.IconButton__icon-d01f27 {
  fill: currentColor;
}

.IconButton__hidden-icon-adfa4b {
  visibility: hidden;
}

.IconButton__xsmall-a63343 {
  min-width: 24px;
  height: 24px;
  padding: 0 4px;
}

.IconButton__small-ca5227 {
  min-width: 32px;
  height: 32px;
  padding: 0 8px;
}

.IconButton__medium-f18d9c {
  min-width: 36px;
  height: 36px;
  padding: 0 6px;
}

.IconButton__big-dfc735 {
  min-width: 40px;
  height: 40px;
  padding: 0 4px;
}

.IconButton__large-af49f7 {
  min-width: 48px;
  height: 48px;
  padding: 0 8px;
}

.IconButton__mlarge-e22166 {
  min-width: 52px;
  height: 52px;
  padding: 0 8px;
}

.IconButton__xlarge-eef119 {
  min-width: 64px;
  height: 64px;
  padding: 0 16px;
}

.IconButton__text-c58fa5 {
  font: var(--font-body-2);
  letter-spacing: var(--font-body-2);
  color: inherit;
  padding-inline-start: 4px;
  min-width: 20px;
  text-align: center;
}

.IconButton__loader-b3d9ff {
  position: absolute;
  left: 50%;
  top: 50%;
  z-index: 1;
  margin-inline-start: -8px;
  margin-top: -8px;
}

.IconButton__shape-square-fc6106 {
  border-radius: 12px;
}

.IconButton__shape-circle-f08c73 {
  border-radius: 50%;
}

.IconButton__theme-1-c008f4 {
  --ib-color: var(--brand-primary-40);
  --ib-color-hover: var(--brand-primary-40);
  --ib-color-active: var(--brand-primary-50);
  --ib-color-disabled: var(--brand-primary-40);
  --ib-background: transparent;
  --ib-background-hover: var(--base-20);
  --ib-background-active: var(--base-30);
  --ib-background-disabled: transparent;
}

.IconButton__theme-1_1-af5d18 {
  /* not transparent background */
  --ib-color: var(--brand-primary-40);
  --ib-color-hover: var(--brand-primary-40);
  --ib-color-active: var(--brand-primary-50);
  --ib-color-disabled: var(--brand-primary-40);
  --ib-background: var(--base-0);
  --ib-background-hover: var(--base-20);
  --ib-background-active: var(--base-30);
}

.IconButton__theme-2-f875eb,
.IconButton__theme-8-edeefd {
  --ib-color: var(--base-120);
  --ib-color-hover: var(--base-120);
  --ib-color-active: var(--base-120);
  --ib-color-disabled: var(--base-50);
  --ib-background: transparent;
  --ib-background-hover: var(--base-120_04);
  --ib-background-active: var(--base-120_08);
  --ib-background-disabled: transparent;
}

.IconButton__theme-2_1-f58df5 {
  /* not transparent background */
  --ib-color: var(--base-120);
  --ib-color-hover: var(--base-120);
  --ib-color-active: var(--base-120);
  --ib-color-disabled: var(--base-40);
  --ib-background: var(--base-0);
  --ib-background-hover: var(--base-20);
  --ib-background-active: var(--base-30);
  --ib-background-disabled: var(--base-0);
}

.IconButton__theme-6-a06321 {
  --ib-color: var(--base-120);
  --ib-color-hover: var(--base-120);
  --ib-color-active: var(--base-120);
  --ib-color-disabled: var(--base-60);
  --ib-background: var(--base-20);
  --ib-background-hover: var(--base-30);
  --ib-background-active: var(--base-40);
  --ib-background-disabled: var(--base-20);
}

.IconButton__theme-9-d6731d {
  --ib-color: var(--addition-50);
  --ib-color-hover: var(--addition-50);
  --ib-color-active: var(--addition-50);
  --ib-color-disabled: var(--addition-50_50);
  --ib-background: var(--danger-40);
  --ib-background-hover: var(--danger-40_90);
  --ib-background-active: var(--danger-40_80);
  --ib-background-disabled: var(--danger-40_40);
}

.IconButton__theme-10-aafa07 {
  --ib-color: var(--addition-50);
  --ib-color-hover: var(--addition-50);
  --ib-color-active: var(--addition-50);
  --ib-color-disabled: var(--addition-50_50);
  --ib-background: var(--success-40);
  --ib-background-hover: var(--success-40_90);
  --ib-background-active: var(--success-40_80);
  --ib-background-disabled: var(--success-40_40);
}

.IconButton__theme-11-cfc4af {
  --ib-color: var(--addition-50);
  --ib-color-hover: var(--addition-50);
  --ib-color-active: var(--addition-50);
  --ib-color-disabled: var(--addition-50_50);
  --ib-background: transparent;
  --ib-background-hover: var(--addition-50_05);
  --ib-background-active: var(--addition-50_10);
  --ib-background-disabled: transparent;
}

.IconButton__theme-12-c8fcbc {
  --ib-color: var(--addition-50);
  --ib-color-hover: var(--addition-50);
  --ib-color-active: var(--addition-50);
  --ib-color-disabled: var(--addition-50_50);
  --ib-background: var(--addition-110_70);
  --ib-background-hover: var(--addition-110_80);
  --ib-background-active: var(--addition-110_90);
  --ib-background-disabled: var(--addition-110_70);
}

.IconButton__theme-13-c9b2a0 {
  --ib-color: var(--addition-80);
  --ib-color-hover: var(--addition-80_90);
  --ib-color-active: var(--addition-80_70);
  --ib-color-disabled: var(--addition-80_20);
  --ib-background: var(--addition-50);
  --ib-background-hover: var(--addition-50);
  --ib-background-active: var(--addition-50);
  --ib-background-disabled: var(--addition-50);
}

.IconButton__theme-14-ac8036 {
  --ib-color: var(--addition-50_70);
  --ib-color-hover: var(--addition-50);
  --ib-color-active: var(--addition-50);
  --ib-color-disabled: var(--addition-50);
  --ib-background: transparent;
  --ib-background-hover: var(--addition-50_10);
  --ib-background-active: var(--addition-50_20);
  --ib-background-disabled: var(--addition-50_10);
}

.IconButton__theme-15-a460e1 {
  --ib-color: var(--base-80);
  --ib-color-hover: var(--base-80);
  --ib-color-active: var(--base-80);
  --ib-color-disabled: var(--base-50);
  --ib-background: transparent;
  --ib-background-hover: var(--base-120_04);
  --ib-background-active: var(--base-120_08);
  --ib-background-disabled: transparent;
}

.IconButton__theme-16-fdc0b7 {
  --ib-color: var(--brand-primary-40);
  --ib-color-hover: var(--brand-primary-40);
  --ib-color-active: var(--brand-primary-40);
  --ib-color-disabled: var(--brand-primary-20);
  --ib-background: transparent;
  --ib-background-hover: var(--base-20);
  --ib-background-active: var(--base-30);
  --ib-background-disabled: transparent;
}

.IconButton__theme-19-d013e7 {
  --ib-color: var(--base-80);
  --ib-color-hover: var(--base-80);
  --ib-color-active: var(--base-80);
  --ib-color-disabled: var(--base-40);
  --ib-background: transparent;
  --ib-background-hover: var(--base-120_04);
  --ib-background-active: var(--base-120_08);
  --ib-background-disabled: transparent;
}

.IconButton__theme-20-aaa753 {
  --ib-color: var(--addition-50);
  --ib-color-hover: var(--addition-50);
  --ib-color-active: var(--addition-50);
  --ib-color-disabled: var(--addition-60);
  --ib-background: var(--brand-primary-40);
  --ib-background-hover: var(--brand-primary-50);
  --ib-background-active: var(--brand-primary-60);
  --ib-background-disabled: var(--brand-primary-20);
}

.IconButton__theme-21-a6c491 {
  --ib-color: var(--addition-50);
  --ib-color-hover: var(--addition-50);
  --ib-color-active: var(--addition-50);
  --ib-color-disabled: var(--addition-50);
  --ib-background: transparent;
  --ib-background-hover: transparent;
  --ib-background-active: transparent;
  --ib-background-disabled: transparent;
}

.IconButton__theme-23-cbdc96 {
  --ib-color: var(--addition-50);
  --ib-color-hover: var(--addition-50);
  --ib-color-active: var(--addition-50);
  --ib-color-disabled: var(--addition-50_50);
  --ib-background: transparent;
  --ib-background-hover: var(--addition-50_10);
  --ib-background-active: var(--addition-50_10);
  --ib-background-disabled: var(--addition-50_10);
}

.IconButton__theme-secondary-filled-d5e0f2 {
  --ib-color: var(--base-80);
  --ib-color-hover: var(--base-80);
  --ib-color-active: var(--base-80);
  --ib-color-disabled: var(--base-80);
  --ib-background: var(--base-20);
  --ib-background-hover: var(--base-30);
  --ib-background-active: var(--base-40);
  --ib-background-disabled: var(--base-20);
}

/* Figma: Custom Button -> Icon Button Secondary */
.IconButton__theme-outline-d7390b {
  --ib-color: var(--base-120);
  --ib-color-hover: var(--base-120);
  --ib-color-active: var(--base-120);
  --ib-color-disabled: var(--base-50);
  --ib-background: transparent;
  --ib-background-hover: var(--base-20);
  --ib-background-active: var(--base-30);
  --ib-background-disabled: var(--base-20);
  --ib-border-color: var(--base-20);
  --ib-border-color-active: var(--base-30);
  --ib-border-width: 1px;
}

.IconButton__theme-secondary-custom-e746a6 {
  --ib-color: var(--base-120);
  --ib-color-hover: var(--base-120);
  --ib-color-active: var(--base-120);
  --ib-color-disabled: var(--base-120);
  --ib-background: transparent;
  --ib-background-hover: var(--base-15);
  --ib-background-active: var(--base-10);
  --ib-background-disabled: transparent;
  --ib-border-color: var(--base-20);
  --ib-border-width: 1px;
}

.IconButton__theme-chat-average-c697f3 {
  --ib-color: var(--text-on-background);
  --ib-color-hover: var(--text-on-background);
  --ib-color-active: var(--text-on-background);
  --ib-color-disabled: var(--text-on-background);
  --ib-background: linear-gradient(0deg, var(--base-120_08), var(--base-120_08)),
    linear-gradient(0deg, var(--chat-background-average), var(--chat-background-average));
  --ib-background-hover: linear-gradient(0deg, var(--base-120_20), var(--base-120_20)),
    linear-gradient(0deg, var(--chat-background-average), var(--chat-background-average));
  --ib-background-active: linear-gradient(0deg, var(--base-120_20), var(--base-120_20)),
    linear-gradient(0deg, var(--chat-background-average), var(--chat-background-average));
  --ib-background-disabled: transparent;
}

.IconButton__theme-secondary-custom-e746a6.IconButton__disabled-f4af89 {
  opacity: 0.5;
}`, "",{"version":3,"sources":["webpack://./../../packages/ui-kit/src/IconButton/IconButton.styles.m.css"],"names":[],"mappings":"AAAA;EACE,uBAAA;EACA,oBAAA;EACA,8BAAA;EAEA,cAAA;EACA,kBAAA;EACA,oBAAA;EACA,uBAAA;EACA,mBAAA;EACA,iDAAA;EACA,eAAA;EACA,sBAAA;EACA,sBAAA;EACA,gCAAA;EACA,sCAAA;EACA,wCAAA;EACA,2DAAA;AAAF;;AAGA;EACE,kCAAA;AAAF;;AAGA;;EAEE,4BAAA;EACA,sCAAA;AAAF;;AAGA;;EAEE,wCAAA;AAAF;;AAGA;EACE,6BAAA;EACA,uCAAA;AAAF;;AAGA;EACE,yCAAA;AAAF;;AAGA;EACE,4BAAA;EACA,sCAAA;AAAF;;AAGA;EACE,wCAAA;AAAF;;AAGA;EACE,eAAA;EACA,+BAAA;EACA,yCAAA;AAAF;;AAEA;EACE,2CAAA;AACF;;AAEA;EACE,kBAAA;EACA,UAAA;EACA,WAAA;EACA,QAAA;EACA,qBAAA;EACA,kBAAA;EACA,+BAAA;EACA,mCAAA;EACA,kCAAA;AACF;;AAEA;EACE,oBAAA;AACF;;AAEA;EACE,YAAA;AACF;;AAEA;EACE,kBAAA;AACF;;AAEA;EACE,kBAAA;AACF;;AAEA;EACE,eAAA;EACA,YAAA;EACA,cAAA;AACF;;AAEA;EACE,eAAA;EACA,YAAA;EACA,cAAA;AACF;;AAEA;EACE,eAAA;EACA,YAAA;EACA,cAAA;AACF;;AAEA;EACE,eAAA;EACA,YAAA;EACA,cAAA;AACF;;AAEA;EACE,eAAA;EACA,YAAA;EACA,cAAA;AACF;;AAEA;EACE,eAAA;EACA,YAAA;EACA,cAAA;AACF;;AAEA;EACE,eAAA;EACA,YAAA;EACA,eAAA;AACF;;AAEA;EACE,wBAAA;EACA,kCAAA;EACA,cAAA;EACA,yBAAA;EACA,eAAA;EACA,kBAAA;AACF;;AAEA;EACE,kBAAA;EACA,SAAA;EACA,QAAA;EACA,UAAA;EACA,yBAAA;EACA,gBAAA;AACF;;AAEA;EACE,mBAAA;AACF;;AAEA;EACE,kBAAA;AACF;;AAEA;EACE,mCAAA;EACA,yCAAA;EACA,0CAAA;EACA,4CAAA;EACA,4BAAA;EACA,qCAAA;EACA,sCAAA;EACA,qCAAA;AACF;;AAEA;EACE,+BAAA;EACA,mCAAA;EACA,yCAAA;EACA,0CAAA;EACA,4CAAA;EACA,8BAAA;EACA,qCAAA;EACA,sCAAA;AACF;;AAEA;;EAEE,2BAAA;EACA,iCAAA;EACA,kCAAA;EACA,mCAAA;EACA,4BAAA;EACA,yCAAA;EACA,0CAAA;EACA,qCAAA;AACF;;AAEA;EACE,+BAAA;EACA,2BAAA;EACA,iCAAA;EACA,kCAAA;EACA,mCAAA;EACA,8BAAA;EACA,qCAAA;EACA,sCAAA;EACA,uCAAA;AACF;;AAEA;EACE,2BAAA;EACA,iCAAA;EACA,kCAAA;EACA,mCAAA;EACA,+BAAA;EACA,qCAAA;EACA,sCAAA;EACA,wCAAA;AACF;;AAEA;EACE,8BAAA;EACA,oCAAA;EACA,qCAAA;EACA,0CAAA;EACA,iCAAA;EACA,0CAAA;EACA,2CAAA;EACA,6CAAA;AACF;;AAEA;EACE,8BAAA;EACA,oCAAA;EACA,qCAAA;EACA,0CAAA;EACA,kCAAA;EACA,2CAAA;EACA,4CAAA;EACA,8CAAA;AACF;;AAEA;EACE,8BAAA;EACA,oCAAA;EACA,qCAAA;EACA,0CAAA;EACA,4BAAA;EACA,4CAAA;EACA,6CAAA;EACA,qCAAA;AACF;;AAEA;EACE,8BAAA;EACA,oCAAA;EACA,qCAAA;EACA,0CAAA;EACA,uCAAA;EACA,6CAAA;EACA,8CAAA;EACA,gDAAA;AACF;;AAEA;EACE,8BAAA;EACA,uCAAA;EACA,wCAAA;EACA,0CAAA;EACA,mCAAA;EACA,yCAAA;EACA,0CAAA;EACA,4CAAA;AACF;;AAEA;EACE,iCAAA;EACA,oCAAA;EACA,qCAAA;EACA,uCAAA;EACA,4BAAA;EACA,4CAAA;EACA,6CAAA;EACA,+CAAA;AACF;;AAEA;EACE,0BAAA;EACA,gCAAA;EACA,iCAAA;EACA,mCAAA;EACA,4BAAA;EACA,yCAAA;EACA,0CAAA;EACA,qCAAA;AACF;;AAEA;EACE,mCAAA;EACA,yCAAA;EACA,0CAAA;EACA,4CAAA;EACA,4BAAA;EACA,qCAAA;EACA,sCAAA;EACA,qCAAA;AACF;;AAEA;EACE,0BAAA;EACA,gCAAA;EACA,iCAAA;EACA,mCAAA;EACA,4BAAA;EACA,yCAAA;EACA,0CAAA;EACA,qCAAA;AACF;;AAEA;EACE,8BAAA;EACA,oCAAA;EACA,qCAAA;EACA,uCAAA;EACA,wCAAA;EACA,8CAAA;EACA,+CAAA;EACA,iDAAA;AACF;;AAEA;EACE,8BAAA;EACA,oCAAA;EACA,qCAAA;EACA,uCAAA;EACA,4BAAA;EACA,kCAAA;EACA,mCAAA;EACA,qCAAA;AACF;;AAEA;EACE,8BAAA;EACA,oCAAA;EACA,qCAAA;EACA,0CAAA;EACA,4BAAA;EACA,4CAAA;EACA,6CAAA;EACA,+CAAA;AACF;;AAEA;EACE,0BAAA;EACA,gCAAA;EACA,iCAAA;EACA,mCAAA;EACA,+BAAA;EACA,qCAAA;EACA,sCAAA;EACA,wCAAA;AACF;;AAEA,kDAAA;AACA;EACE,2BAAA;EACA,iCAAA;EACA,kCAAA;EACA,mCAAA;EACA,4BAAA;EACA,qCAAA;EACA,sCAAA;EACA,wCAAA;EAEA,iCAAA;EACA,wCAAA;EACA,sBAAA;AAAF;;AAGA;EACE,2BAAA;EACA,iCAAA;EACA,kCAAA;EACA,oCAAA;EACA,4BAAA;EACA,qCAAA;EACA,sCAAA;EACA,qCAAA;EAEA,iCAAA;EACA,sBAAA;AADF;;AAIA;EACE,qCAAA;EACA,2CAAA;EACA,4CAAA;EACA,8CAAA;EACA;yFAAA;EAEA;yFAAA;EAEA;yFAAA;EAEA,qCAAA;AADF;;AAIA;EACE,YAAA;AADF","sourcesContent":[".container {\n  --ib-border-radius: 50%;\n  --ib-border-width: 0;\n  --ib-border-color: transparent;\n\n  flex-shrink: 0;\n  position: relative;\n  display: inline-flex;\n  justify-content: center;\n  align-items: center;\n  transition: background 0.3s ease, color 0.3s ease;\n  cursor: pointer;\n  box-sizing: border-box;\n  color: var(--ib-color);\n  background: var(--ib-background);\n  border-radius: var(--ib-border-radius);\n  -webkit-tap-highlight-color: transparent;\n  border: var(--ib-border-width) solid var(--ib-border-color);\n}\n\n.container .dot-badge {\n  border-color: var(--ib-background);\n}\n\n.container:hover,\n.container.active {\n  color: var(--ib-color-hover);\n  background: var(--ib-background-hover);\n}\n\n.container:hover .dot-badge,\n.container.active .dot-badge {\n  border-color: var(--ib-background-hover);\n}\n\n.container:active {\n  color: var(--ib-color-active);\n  background: var(--ib-background-active);\n}\n\n.container:active .dot-badge {\n  border-color: var(--ib-background-active);\n}\n\n.container:focus {\n  color: var(--ib-color-hover);\n  background: var(--ib-background-hover);\n}\n\n.container:focus .dot-badge {\n  border-color: var(--ib-background-hover);\n}\n\n.container:disabled {\n  cursor: default;\n  color: var(--ib-color-disabled);\n  background: var(--ib-background-disabled);\n}\n.container:disabled .dot-badge {\n  border-color: var(--ib-background-disabled);\n}\n\n.dot-badge {\n  position: absolute;\n  width: 8px;\n  height: 8px;\n  top: 6px;\n  inset-inline-end: 6px;\n  border-radius: 50%;\n  border: solid 2px var(--base-0);\n  background: var(--brand-primary-40);\n  transition: border-color 0.3s ease;\n}\n\n.disabled {\n  pointer-events: none;\n}\n\n.disabled-icon {\n  opacity: 0.5;\n}\n\n.icon {\n  fill: currentColor;\n}\n\n.hidden-icon {\n  visibility: hidden;\n}\n\n.xsmall {\n  min-width: 24px;\n  height: 24px;\n  padding: 0 4px;\n}\n\n.small {\n  min-width: 32px;\n  height: 32px;\n  padding: 0 8px;\n}\n\n.medium {\n  min-width: 36px;\n  height: 36px;\n  padding: 0 6px;\n}\n\n.big {\n  min-width: 40px;\n  height: 40px;\n  padding: 0 4px;\n}\n\n.large {\n  min-width: 48px;\n  height: 48px;\n  padding: 0 8px;\n}\n\n.mlarge {\n  min-width: 52px;\n  height: 52px;\n  padding: 0 8px;\n}\n\n.xlarge {\n  min-width: 64px;\n  height: 64px;\n  padding: 0 16px;\n}\n\n.text {\n  font: var(--font-body-2);\n  letter-spacing: var(--font-body-2);\n  color: inherit;\n  padding-inline-start: 4px;\n  min-width: 20px;\n  text-align: center;\n}\n\n.loader {\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  z-index: 1;\n  margin-inline-start: -8px;\n  margin-top: -8px;\n}\n\n.shape-square {\n  border-radius: 12px;\n}\n\n.shape-circle {\n  border-radius: 50%;\n}\n\n.theme-1 {\n  --ib-color: var(--brand-primary-40);\n  --ib-color-hover: var(--brand-primary-40);\n  --ib-color-active: var(--brand-primary-50);\n  --ib-color-disabled: var(--brand-primary-40);\n  --ib-background: transparent;\n  --ib-background-hover: var(--base-20);\n  --ib-background-active: var(--base-30);\n  --ib-background-disabled: transparent;\n}\n\n.theme-1_1 {\n  /* not transparent background */\n  --ib-color: var(--brand-primary-40);\n  --ib-color-hover: var(--brand-primary-40);\n  --ib-color-active: var(--brand-primary-50);\n  --ib-color-disabled: var(--brand-primary-40);\n  --ib-background: var(--base-0);\n  --ib-background-hover: var(--base-20);\n  --ib-background-active: var(--base-30);\n}\n\n.theme-2,\n.theme-8 {\n  --ib-color: var(--base-120);\n  --ib-color-hover: var(--base-120);\n  --ib-color-active: var(--base-120);\n  --ib-color-disabled: var(--base-50);\n  --ib-background: transparent;\n  --ib-background-hover: var(--base-120_04);\n  --ib-background-active: var(--base-120_08);\n  --ib-background-disabled: transparent;\n}\n\n.theme-2_1 {\n  /* not transparent background */\n  --ib-color: var(--base-120);\n  --ib-color-hover: var(--base-120);\n  --ib-color-active: var(--base-120);\n  --ib-color-disabled: var(--base-40);\n  --ib-background: var(--base-0);\n  --ib-background-hover: var(--base-20);\n  --ib-background-active: var(--base-30);\n  --ib-background-disabled: var(--base-0);\n}\n\n.theme-6 {\n  --ib-color: var(--base-120);\n  --ib-color-hover: var(--base-120);\n  --ib-color-active: var(--base-120);\n  --ib-color-disabled: var(--base-60);\n  --ib-background: var(--base-20);\n  --ib-background-hover: var(--base-30);\n  --ib-background-active: var(--base-40);\n  --ib-background-disabled: var(--base-20);\n}\n\n.theme-9 {\n  --ib-color: var(--addition-50);\n  --ib-color-hover: var(--addition-50);\n  --ib-color-active: var(--addition-50);\n  --ib-color-disabled: var(--addition-50_50);\n  --ib-background: var(--danger-40);\n  --ib-background-hover: var(--danger-40_90);\n  --ib-background-active: var(--danger-40_80);\n  --ib-background-disabled: var(--danger-40_40);\n}\n\n.theme-10 {\n  --ib-color: var(--addition-50);\n  --ib-color-hover: var(--addition-50);\n  --ib-color-active: var(--addition-50);\n  --ib-color-disabled: var(--addition-50_50);\n  --ib-background: var(--success-40);\n  --ib-background-hover: var(--success-40_90);\n  --ib-background-active: var(--success-40_80);\n  --ib-background-disabled: var(--success-40_40);\n}\n\n.theme-11 {\n  --ib-color: var(--addition-50);\n  --ib-color-hover: var(--addition-50);\n  --ib-color-active: var(--addition-50);\n  --ib-color-disabled: var(--addition-50_50);\n  --ib-background: transparent;\n  --ib-background-hover: var(--addition-50_05);\n  --ib-background-active: var(--addition-50_10);\n  --ib-background-disabled: transparent;\n}\n\n.theme-12 {\n  --ib-color: var(--addition-50);\n  --ib-color-hover: var(--addition-50);\n  --ib-color-active: var(--addition-50);\n  --ib-color-disabled: var(--addition-50_50);\n  --ib-background: var(--addition-110_70);\n  --ib-background-hover: var(--addition-110_80);\n  --ib-background-active: var(--addition-110_90);\n  --ib-background-disabled: var(--addition-110_70);\n}\n\n.theme-13 {\n  --ib-color: var(--addition-80);\n  --ib-color-hover: var(--addition-80_90);\n  --ib-color-active: var(--addition-80_70);\n  --ib-color-disabled: var(--addition-80_20);\n  --ib-background: var(--addition-50);\n  --ib-background-hover: var(--addition-50);\n  --ib-background-active: var(--addition-50);\n  --ib-background-disabled: var(--addition-50);\n}\n\n.theme-14 {\n  --ib-color: var(--addition-50_70);\n  --ib-color-hover: var(--addition-50);\n  --ib-color-active: var(--addition-50);\n  --ib-color-disabled: var(--addition-50);\n  --ib-background: transparent;\n  --ib-background-hover: var(--addition-50_10);\n  --ib-background-active: var(--addition-50_20);\n  --ib-background-disabled: var(--addition-50_10);\n}\n\n.theme-15 {\n  --ib-color: var(--base-80);\n  --ib-color-hover: var(--base-80);\n  --ib-color-active: var(--base-80);\n  --ib-color-disabled: var(--base-50);\n  --ib-background: transparent;\n  --ib-background-hover: var(--base-120_04);\n  --ib-background-active: var(--base-120_08);\n  --ib-background-disabled: transparent;\n}\n\n.theme-16 {\n  --ib-color: var(--brand-primary-40);\n  --ib-color-hover: var(--brand-primary-40);\n  --ib-color-active: var(--brand-primary-40);\n  --ib-color-disabled: var(--brand-primary-20);\n  --ib-background: transparent;\n  --ib-background-hover: var(--base-20);\n  --ib-background-active: var(--base-30);\n  --ib-background-disabled: transparent;\n}\n\n.theme-19 {\n  --ib-color: var(--base-80);\n  --ib-color-hover: var(--base-80);\n  --ib-color-active: var(--base-80);\n  --ib-color-disabled: var(--base-40);\n  --ib-background: transparent;\n  --ib-background-hover: var(--base-120_04);\n  --ib-background-active: var(--base-120_08);\n  --ib-background-disabled: transparent;\n}\n\n.theme-20 {\n  --ib-color: var(--addition-50);\n  --ib-color-hover: var(--addition-50);\n  --ib-color-active: var(--addition-50);\n  --ib-color-disabled: var(--addition-60);\n  --ib-background: var(--brand-primary-40);\n  --ib-background-hover: var(--brand-primary-50);\n  --ib-background-active: var(--brand-primary-60);\n  --ib-background-disabled: var(--brand-primary-20);\n}\n\n.theme-21 {\n  --ib-color: var(--addition-50);\n  --ib-color-hover: var(--addition-50);\n  --ib-color-active: var(--addition-50);\n  --ib-color-disabled: var(--addition-50);\n  --ib-background: transparent;\n  --ib-background-hover: transparent;\n  --ib-background-active: transparent;\n  --ib-background-disabled: transparent;\n}\n\n.theme-23 {\n  --ib-color: var(--addition-50);\n  --ib-color-hover: var(--addition-50);\n  --ib-color-active: var(--addition-50);\n  --ib-color-disabled: var(--addition-50_50);\n  --ib-background: transparent;\n  --ib-background-hover: var(--addition-50_10);\n  --ib-background-active: var(--addition-50_10);\n  --ib-background-disabled: var(--addition-50_10);\n}\n\n.theme-secondary-filled {\n  --ib-color: var(--base-80);\n  --ib-color-hover: var(--base-80);\n  --ib-color-active: var(--base-80);\n  --ib-color-disabled: var(--base-80);\n  --ib-background: var(--base-20);\n  --ib-background-hover: var(--base-30);\n  --ib-background-active: var(--base-40);\n  --ib-background-disabled: var(--base-20);\n}\n\n/* Figma: Custom Button -> Icon Button Secondary */\n.theme-outline {\n  --ib-color: var(--base-120);\n  --ib-color-hover: var(--base-120);\n  --ib-color-active: var(--base-120);\n  --ib-color-disabled: var(--base-50);\n  --ib-background: transparent;\n  --ib-background-hover: var(--base-20);\n  --ib-background-active: var(--base-30);\n  --ib-background-disabled: var(--base-20);\n\n  --ib-border-color: var(--base-20);\n  --ib-border-color-active: var(--base-30);\n  --ib-border-width: 1px;\n}\n\n.theme-secondary-custom {\n  --ib-color: var(--base-120);\n  --ib-color-hover: var(--base-120);\n  --ib-color-active: var(--base-120);\n  --ib-color-disabled: var(--base-120);\n  --ib-background: transparent;\n  --ib-background-hover: var(--base-15);\n  --ib-background-active: var(--base-10);\n  --ib-background-disabled: transparent;\n\n  --ib-border-color: var(--base-20);\n  --ib-border-width: 1px;\n}\n\n.theme-chat-average {\n  --ib-color: var(--text-on-background);\n  --ib-color-hover: var(--text-on-background);\n  --ib-color-active: var(--text-on-background);\n  --ib-color-disabled: var(--text-on-background);\n  --ib-background: linear-gradient(0deg, var(--base-120_08), var(--base-120_08)),\n    linear-gradient(0deg, var(--chat-background-average), var(--chat-background-average));\n  --ib-background-hover: linear-gradient(0deg, var(--base-120_20), var(--base-120_20)),\n    linear-gradient(0deg, var(--chat-background-average), var(--chat-background-average));\n  --ib-background-active: linear-gradient(0deg, var(--base-120_20), var(--base-120_20)),\n    linear-gradient(0deg, var(--chat-background-average), var(--chat-background-average));\n  --ib-background-disabled: transparent;\n}\n\n.theme-secondary-custom.disabled {\n  opacity: 0.5;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `IconButton__container-eb0b20`,
	"dot-badge": `IconButton__dot-badge-acd0d3`,
	"dotBadge": `IconButton__dot-badge-acd0d3`,
	"active": `IconButton__active-b5eb48`,
	"disabled": `IconButton__disabled-f4af89`,
	"disabled-icon": `IconButton__disabled-icon-fcd4c1`,
	"disabledIcon": `IconButton__disabled-icon-fcd4c1`,
	"icon": `IconButton__icon-d01f27`,
	"hidden-icon": `IconButton__hidden-icon-adfa4b`,
	"hiddenIcon": `IconButton__hidden-icon-adfa4b`,
	"xsmall": `IconButton__xsmall-a63343`,
	"small": `IconButton__small-ca5227`,
	"medium": `IconButton__medium-f18d9c`,
	"big": `IconButton__big-dfc735`,
	"large": `IconButton__large-af49f7`,
	"mlarge": `IconButton__mlarge-e22166`,
	"xlarge": `IconButton__xlarge-eef119`,
	"text": `IconButton__text-c58fa5`,
	"loader": `IconButton__loader-b3d9ff`,
	"shape-square": `IconButton__shape-square-fc6106`,
	"shapeSquare": `IconButton__shape-square-fc6106`,
	"shape-circle": `IconButton__shape-circle-f08c73`,
	"shapeCircle": `IconButton__shape-circle-f08c73`,
	"theme-1": `IconButton__theme-1-c008f4`,
	"theme1": `IconButton__theme-1-c008f4`,
	"theme-1_1": `IconButton__theme-1_1-af5d18`,
	"theme11": `IconButton__theme-1_1-af5d18`,
	"theme-2": `IconButton__theme-2-f875eb`,
	"theme2": `IconButton__theme-2-f875eb`,
	"theme-8": `IconButton__theme-8-edeefd`,
	"theme8": `IconButton__theme-8-edeefd`,
	"theme-2_1": `IconButton__theme-2_1-f58df5`,
	"theme21": `IconButton__theme-2_1-f58df5`,
	"theme-6": `IconButton__theme-6-a06321`,
	"theme6": `IconButton__theme-6-a06321`,
	"theme-9": `IconButton__theme-9-d6731d`,
	"theme9": `IconButton__theme-9-d6731d`,
	"theme-10": `IconButton__theme-10-aafa07`,
	"theme10": `IconButton__theme-10-aafa07`,
	"theme-11": `IconButton__theme-11-cfc4af`,
	"theme11": `IconButton__theme-11-cfc4af`,
	"theme-12": `IconButton__theme-12-c8fcbc`,
	"theme12": `IconButton__theme-12-c8fcbc`,
	"theme-13": `IconButton__theme-13-c9b2a0`,
	"theme13": `IconButton__theme-13-c9b2a0`,
	"theme-14": `IconButton__theme-14-ac8036`,
	"theme14": `IconButton__theme-14-ac8036`,
	"theme-15": `IconButton__theme-15-a460e1`,
	"theme15": `IconButton__theme-15-a460e1`,
	"theme-16": `IconButton__theme-16-fdc0b7`,
	"theme16": `IconButton__theme-16-fdc0b7`,
	"theme-19": `IconButton__theme-19-d013e7`,
	"theme19": `IconButton__theme-19-d013e7`,
	"theme-20": `IconButton__theme-20-aaa753`,
	"theme20": `IconButton__theme-20-aaa753`,
	"theme-21": `IconButton__theme-21-a6c491`,
	"theme21": `IconButton__theme-21-a6c491`,
	"theme-23": `IconButton__theme-23-cbdc96`,
	"theme23": `IconButton__theme-23-cbdc96`,
	"theme-secondary-filled": `IconButton__theme-secondary-filled-d5e0f2`,
	"themeSecondaryFilled": `IconButton__theme-secondary-filled-d5e0f2`,
	"theme-outline": `IconButton__theme-outline-d7390b`,
	"themeOutline": `IconButton__theme-outline-d7390b`,
	"theme-secondary-custom": `IconButton__theme-secondary-custom-e746a6`,
	"themeSecondaryCustom": `IconButton__theme-secondary-custom-e746a6`,
	"theme-chat-average": `IconButton__theme-chat-average-c697f3`,
	"themeChatAverage": `IconButton__theme-chat-average-c697f3`
};
module.exports = ___CSS_LOADER_EXPORT___;
